import { makeStyles } from '@material-ui/core/styles'
import LinearProgress from '@mui/material/LinearProgress'
import { useEffect, useRef, useState } from 'react'
import { POLICY_STATUS_TYPES } from 'src/utils/constants/common'
import { Tooltip, Zoom } from '@mui/material'
import reportDownload from 'src/assets/PolicyTile_Images/Group1277.svg'
import {
  CLICK_TO_DOWNLOAD,
  RENEWAL_POLICY_UNDER_VERIFICATION,
  VERIFICATION_PENDING,
} from 'src/utils/constants/Individual'

const DigitalizingBar = ({ status, documentDownload }) => {
  const classes = useStyles()
  const [progress, setProgress] = useState(0)
  const [buffer, setBuffer] = useState(10)

  const progressRef = useRef(() => {})
  useEffect(() => {
    progressRef.current = () => {
      if (progress > 100) {
        setProgress(0)
        setBuffer(10)
      } else {
        const diff = Math.random() * 10
        const diff2 = Math.random() * 10
        setProgress(progress + diff)
        setBuffer(progress + diff + diff2)
      }
    }
  })

  const verficiationPending = (staus) => {
    return (
      <div className={classes.digitalizingTextContainer}>
        <span className={classes.digitalizingText}>
          {staus !== POLICY_STATUS_TYPES?.renewalUnderDigitalizing
            ? VERIFICATION_PENDING
            : RENEWAL_POLICY_UNDER_VERIFICATION}
        </span>
        <Tooltip
          TransitionComponent={Zoom}
          placement='top'
          title={CLICK_TO_DOWNLOAD}
          arrow
        >
          <img
            src={reportDownload}
            onClick={documentDownload}
            alt='Download'
            className={classes.downloadIcon}
          />
        </Tooltip>
      </div>
    )
  }

  useEffect(() => {
    const timer = setInterval(() => {
      progressRef.current()
    }, 500)

    return () => {
      clearInterval(timer)
    }
  }, [])
  return (
    <div className={classes.mainContainer}>
      <LinearProgress
        variant='buffer'
        value={progress}
        valueBuffer={buffer}
        className={classes.progressContainer}
      />
      {status === POLICY_STATUS_TYPES?.digitalizing ? (
        <span className={classes.digitalizingText}>
          Trovity is Digitalizing your Policy
        </span>
      ) : status === POLICY_STATUS_TYPES?.renewalUnderDigitalizing ? (
        verficiationPending(status)
      ) : (
        verficiationPending(status)
      )}
    </div>
  )
}

export default DigitalizingBar

const useStyles = makeStyles({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
  },
  digitalizingTextContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
  },
  digitalizingText: {
    fontSize: '12px',
    fontWeight: 'bold',
  },
  progressContainer: {
    width: '100%',
    backgroundColor: 'rgb(30, 119, 104) !important',
    borderRadius: '50px',
    '& .MuiLinearProgress-bar': {
      backgroundColor: 'rgb(30, 119, 104) !important',
    },
  },
  downloadIcon: {
    width: '17px',
    height: '17px',
  },
})
